import styled from 'styled-components';

export const FarmGaleriesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  align-items: center;

  .farm-gallery-image-container {
    width: 300px;
    height: 200px;
    flex: 1 1 auto;
    overflow: hidden;
    position: relative;

    .ant-image,
    .ant-image img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  @media (max-width: 768px) {
    .farm-gallery-image-container {
      width: 100%;
      height: auto;
    }

    .ant-image,
    .ant-image img {
      height: 100%;
    }
  }
`;
